export const GET_INSEMINATION_SUCCESS_REQUEST = "@@ddw.herdnet.sandbox.hnadvice/GET_INSEMINATION_SUCCESS_REQUEST";
export const GET_INSEMINATION_SUCCESS_SUCCESS = "@@ddw.herdnet.sandbox.hnadvice/GET_INSEMINATION_SUCCESS_SUCCESS";
export const GET_INSEMINATION_SUCCESS_FAILURE = "@@ddw.herdnet.sandbox.hnadvice/GET_INSEMINATION_SUCCESS_FAILURE";
